import { Component, OnInit, OnDestroy } from '@angular/core';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { LoginAwareComponent } from '../login-aware-component';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

/**
 * Top-right navigation menu, which is displayed to logged in users only.
 */
@Component({
  selector: 'app-nav-menu-right',
  templateUrl: './nav-menu-right.component.html',
  styleUrls: ['./nav-menu-right.component.scss']
})
export class NavMenuRightComponent extends LoginAwareComponent implements OnInit, OnDestroy {

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    broadcastService: BroadcastService,
    authService: MsalService) {
    super(diagnosticsFactory.create('NavMenuRightComponent'), broadcastService, authService);
  }
}
